import React, { useEffect } from "react";
import Hero from '../elements/Hero';
import JunkBanner from '../img/labortypes.png';
import Title from "../elements/Title";
import Btn from "../elements/Btn";
import Footer from "../elements/Footer";
import RemovalServices from "../elements/RemovalServices";
import hourly from '../img/labor/hourly.png';
import loading from '../img/labor/loading.png';
import hourlyIcon from '../img/labor/hourlyIcon.png';
import loadingIcon from '../img/labor/loadingIcon.png';
import packing from '../img/labor/packing.png';
import packingIcon from '../img/labor/packingIcon.png';
import AdditionalServices from "../elements/AdditionalServices";
import HappyCustomers from "../elements/HappyCustomers";
import QuickServices from "../elements/QuickServices";
import FreeQuote from "../elements/FreeQuote";
import Newsletter from "../elements/Newsletter";
import user from '../img/testimonial.png';

export default function LaborTypes() {
    const removalService = [
        {
            title: "Labor Only Service",
            des: "Looking for some extra help but don’t want to hire a moving company? We’ve got you covered. Exquisite Moves offers hourly labor service that can assist you with any parts of your move."
        },
        {
            title: "Truck Loading & Unloading",
            des: "Loading and unloading your moving truck or storage unit is often the hardest part of a do-it-yourself move. Why not hire an experienced team of packers and movers to help make your next local or long distance move easier?"
        },
        {
            title: "Furniture Moving & Rearrangement",
            des: "We have the experience and professional training to properly handle your most cherished furniture. From heavy desks and office equipment to antique furniture and home décor, our American Moving and Storage..."
        },
        {
            title: "Furniture Moving & Rearrangement",
            des: "We have the experience and professional training to properly handle your most cherished furniture. From heavy desks and office equipment to antique furniture and home décor, our American Moving and Storage..."
        }
    ]

    const customers = [
        {
            title: "Excellent service, on time. Careful, courteous!",
            description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
            user: "Dianne Russell",
            userPost: "Exquisitemoves Director",
            useravatar: user,
            rating: "4.9"
        },
        {
            title: "Excellent service, on time. Careful, courteous!",
            description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
            user: "Dianne Russell",
            userPost: "Exquisitemoves Director",
            useravatar: user,
            rating: "4.9"
        },
        {
            title: "Excellent service, on time. Careful, courteous!",
            description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
            user: "Dianne Russell",
            userPost: "Exquisitemoves Director",
            useravatar: user,
            rating: "4.9"
        },
        {
            title: "Excellent service, on time. Careful, courteous!",
            description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
            user: "Dianne Russell",
            userPost: "Exquisitemoves Director",
            useravatar: user,
            rating: "4.9"
        },
        {
            title: "Excellent service, on time. Careful, courteous!",
            description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
            user: "Dianne Russell",
            userPost: "Exquisitemoves Director",
            useravatar: user,
            rating: "4.9"
        },

    ]

    return (
        <>
            <Hero bg={JunkBanner} clsName="junkbanner_sec">
                <div className='pt-3 pt-sm-4 pt-lg-5 bannerTri junk_banner' >
                    <div className='row' >
                        <div className='col-md-12 pb-5 mt-3' >
                            <div className='banner_content py-0 pt-4' >
                                <Title mainClass="text-center"
                                    titleclass="lg text-white mb-2"
                                    desclass="text-center mt-3 mb-3 mb-sm-5"
                                    title={<>Hourly Labor & Moving Services</>}
                                    des="Sit Back and Let The ExquisiteMoves Do The Work. When you need an extra set of hands—or an entire team—to complete a home or office project, ExquisiteMoves is here to help." />
                                <Btn class="mb-4 m-auto d-table"
                                    arrow={true}
                                    wave={true}
                                    href="#"
                                >Book now Labor & Moving Service</Btn>
                            </div>
                        </div>
                    </div>
                </div>
            </Hero>
            <RemovalServices />
            <div className='delivaryAffordable py-3 py-sm-5' >
                <div className='container' >
                    <Title mainClass="mb-3"
                        subheading="No Matter The Job, The Exquisite Moves Can Help"
                        subclass="border-none text-center text-uppercase mb-3 mb-lg-0"
                        titleclass="md heading text-dark text-center  mb-3 mt-0 mt-lg-3"
                        desclass="mb-0 text-center w-50 m-auto d-table"
                        title={<>Friendly & Affordable Home & Business <br></br> Service Solutions</>}
                        des="When you need an extra set of hands—or an entire team—to complete a home or office project, Exquisite Moves is here to help. We’ll take care of all the heavy lifting, re-arranging, and a lot more so you can sit back and relax."
                    />
                </div>
            </div>
            <div className="bg_wrapper mt-0">
                <div className="container position-relative">
                    <div className="joning" >
                        <svg width="793" height="1311" viewBox="0 0 793 1311" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M72.6337 1C51.2533 30.5 7.99874 91.5 3.14756 153C-0.204875 195.5 -0.467888 272.627 29.3871 339.5C108.296 516.252 344.261 462 492.466 484.5C596.403 500.279 665.585 522.863 727.163 600C794.22 684 806.788 780.667 776.241 883.5C736.882 1016 635.811 1074.5 517.247 1150C391.946 1229.79 72.1477 1309.5 72.1477 1309.5" stroke="#AFC4D6" stroke-width="2" stroke-dasharray="8 8" />
                        </svg>
                    </div>
                    <div className="serviceSec pt-4 pb-5 mb-lg-5" >
                        <div className="row align-items-center " >
                            <div className="col-xl-6 col-lg-7 pe-lg-4" >
                                <div className="serviceTag mb-4" >
                                    <div className="d-flex align-items-center" >
                                        <img src={hourlyIcon} alt="service" className="img-fluid" />
                                        <h3>Hourly Labor Services</h3>
                                    </div>
                                    <a className="linktag" href="#" >Learn More &nbsp; <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.2" d="M9.5 0.749817C14.3256 0.749817 18.25 4.67507 18.25 9.49982C18.25 14.3246 14.3256 18.2498 9.5 18.2498C4.67525 18.2498 0.75 14.3246 0.75 9.49982C0.75 4.67507 4.67525 0.749817 9.5 0.749817" fill="#FF9900" />
                                        <path d="M8.23774 5.80672C8.40486 5.80672 8.57286 5.87059 8.70061 5.99834L11.7517 9.03459C11.8751 9.15797 11.9442 9.32509 11.9442 9.50009C11.9442 9.67422 11.8751 9.84134 11.7517 9.96472L8.70061 13.0027C8.44424 13.2582 8.02949 13.2582 7.77311 13.001C7.51761 12.7437 7.51849 12.3281 7.77486 12.0726L10.3587 9.50009L7.77486 6.92759C7.51849 6.67209 7.51761 6.25734 7.77311 6.00009C7.90086 5.87059 8.06974 5.80672 8.23774 5.80672" fill="#FF9900" />
                                    </svg>
                                    </a>
                                </div>
                                <Title mainClass="mb-3 ps-lg-5 ms-lg-3"
                                    titleclass="lg heading text-dark text-start mb-4"
                                    desclass="mb-0"
                                    title={<>Hourly Labor<br></br> Services</>}
                                    des="Exquisite Moves offers hourly labor service that can assist you with any parts of your move. We can help pack, unpack, load, or unload your moving truck. Just want to rearrange your living room? We’ve got some hands for that. Ready to store some heavy boxes in the attic? Our team can help do the heavy lifting."
                                />
                            </div>
                            <div className="col-xl-6 col-lg-5 pt-3 pt-lg-0 ps-xl-5" >
                                <img src={hourly} className="img-fluid d-table m-auto" alt="services" />
                            </div>
                        </div>
                    </div>

                    <div className="serviceSec pt-4 pb-5 mb-lg-5" >
                        <div className="row align-items-center flex-lg-row-reverse " >
                            <div className="col-xl-6 col-lg-7 ps-lg-4" >
                                <div className="serviceTag mb-4" >
                                <div className="d-flex align-items-center" >
                                    <img src={loadingIcon} alt="service" className="img-fluid" />
                                    <h3>Truck Loading & Unloading Services</h3>
                                    </div>
                                    <a className="linktag" href="#" >Learn More &nbsp; <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.2" d="M9.5 0.749817C14.3256 0.749817 18.25 4.67507 18.25 9.49982C18.25 14.3246 14.3256 18.2498 9.5 18.2498C4.67525 18.2498 0.75 14.3246 0.75 9.49982C0.75 4.67507 4.67525 0.749817 9.5 0.749817" fill="#FF9900" />
                                        <path d="M8.23774 5.80672C8.40486 5.80672 8.57286 5.87059 8.70061 5.99834L11.7517 9.03459C11.8751 9.15797 11.9442 9.32509 11.9442 9.50009C11.9442 9.67422 11.8751 9.84134 11.7517 9.96472L8.70061 13.0027C8.44424 13.2582 8.02949 13.2582 7.77311 13.001C7.51761 12.7437 7.51849 12.3281 7.77486 12.0726L10.3587 9.50009L7.77486 6.92759C7.51849 6.67209 7.51761 6.25734 7.77311 6.00009C7.90086 5.87059 8.06974 5.80672 8.23774 5.80672" fill="#FF9900" />
                                    </svg>
                                    </a>
                                </div>
                                <Title mainClass="mb-3 ps-lg-5 ms-lg-3"
                                    titleclass="lg heading text-dark text-start mb-4"
                                    desclass="mb-0"
                                    title={<>Truck Loading & Unloading Services</>}
                                    des="Loading and unloading your moving truck or storage unit is often the hardest part of a do-it-yourself move. Why not hire an experienced team of packers and movers to help make your next local or long-distance move easier? Exquisite Moves Hauling Junk & Moving is proud to offer professional move labor services nationwide to help make a successful local, long-distance, or commercial move. When you schedule our team for loading and unloading labor assistance, you can rest assured that your move is in expert hands."
                                />
                            </div>
                            <div className="col-xl-6 col-lg-5 pt-3 pt-lg-0 pe-xl-5" >
                                <img src={loading} className="img-fluid " alt="services" />
                            </div>
                        </div>
                    </div>

                    <div className="serviceSec pt-4 pb-5 mb-lg-5" >
                        <div className="row align-items-center " >
                            <div className="col-xl-6 col-lg-7 pe-lg-4" >
                                <div className="serviceTag mb-4" >
                                <div className="d-flex align-items-center" >
                                    <img src={packingIcon} alt="service" className="img-fluid" />
                                    <h3>Professional Packing Services</h3>
                                    </div>
                                    <a className="linktag" href="#" >Learn More &nbsp; <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.2" d="M9.5 0.749817C14.3256 0.749817 18.25 4.67507 18.25 9.49982C18.25 14.3246 14.3256 18.2498 9.5 18.2498C4.67525 18.2498 0.75 14.3246 0.75 9.49982C0.75 4.67507 4.67525 0.749817 9.5 0.749817" fill="#FF9900" />
                                        <path d="M8.23774 5.80672C8.40486 5.80672 8.57286 5.87059 8.70061 5.99834L11.7517 9.03459C11.8751 9.15797 11.9442 9.32509 11.9442 9.50009C11.9442 9.67422 11.8751 9.84134 11.7517 9.96472L8.70061 13.0027C8.44424 13.2582 8.02949 13.2582 7.77311 13.001C7.51761 12.7437 7.51849 12.3281 7.77486 12.0726L10.3587 9.50009L7.77486 6.92759C7.51849 6.67209 7.51761 6.25734 7.77311 6.00009C7.90086 5.87059 8.06974 5.80672 8.23774 5.80672" fill="#FF9900" />
                                    </svg>
                                    </a>
                                </div>
                                <Title mainClass="mb-3 ps-lg-5 ms-lg-3"
                                    titleclass="lg heading text-dark text-start mb-4"
                                    desclass="mb-0"
                                    title={<>Professional Packing <br></br> Services</>}
                                    des="Our team is proud to offer full-service packing solutions in addition to our local and long-distance moving services. From packing up your home or business to organizing your boxes in our state-of-the-art moving trucks, we are dedicated to providing the highest quality customer service. Whether you need full packing, partial packing, or single item packing services, there's nothing our team can't pack for you."
                                />
                            </div>
                            <div className="col-xl-6 col-lg-5 pt-3 pt-lg-0 ps-xl-5" >
                                <img src={packing} className="img-fluid" alt="services" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AdditionalServices title="Additional Services"
        des="Whether You’re Looking For A Little Help Loading And Unloading Your Moving Truck, Or You Want A Full-Service Move Including Packing, Unpacking, Arranging, And Everything In Between, Our Team Is Ready To Help You. We Promise To Provide 100% Satisfaction With Every Project."
         data={removalService} />
            <HappyCustomers customers={customers} />
            <QuickServices />
            <FreeQuote />
            <Newsletter />
            <Footer />
        </>
    )
}
